<template>
  <v-card class="d-flex flex-column dental-main">
    <!-- <history-sidebar v-if="!isEmr && !isIhs" /> -->
    <header-assessment
      class="mt-3"
      :data="headerData"
      pl="2vw"
      pr="2vw"
      mb="1vw"
      title="Assesmen Poli Gigi"
    />
    <v-divider></v-divider>
    <div class="content-wrapper">
      <v-row v-if="!isLoading" no-gutters class="fill-height">
        <v-col class="form-container flex-grow-1" style="flex: 1">
          <!-- EMR -->
          <input-assessment
            ref="assessment"
            v-if="!emrData"
            v-on="$listeners"
            @close-form="$emit('close-form')"
            :patient-data="patient"
            :is-ihs="isIhs"
            :tab="tabs"
          />

          <!-- EMR -->
          <input-assessment
            ref="assessment"
            v-else
            v-on="$listeners"
            @close-form="$emit('close-form')"
            :patient-data="patient"
            :emr-data="emrData"
            :is-ihs="isIhs"
            :is-emr="isEmr"
          />
        </v-col>
        <v-col class="sidebar-container" style="flex: 0.4">
          <!-- v-if="!isEmr && !isIhs" -->
          <history-sidebar
            :header-data="headerData"
            @navigate-to="navigateTo"
            :unit="'Poli Gigi'"
          />
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
// import HistoryAssessment from './HistoryAssessment.vue';
import HistorySidebar from '../AssessmentComponents/HistorySidebarV2.vue';
import InputAssessment from './InputAssessment';
import HeaderAssessment from '../AssessmentComponents/HeaderAssessment.vue';
import formatMixin from '@/mixin/formatMixin';

const moment = require('moment');
// import { formatAddress } from '@/helper';

// api
import { getSocialDataByRmNumber } from '@/fetchApi/patient';

export default {
  name: 'DentalPolyAssestment',
  mixins: [formatMixin],
  components: { InputAssessment, HistorySidebar, HeaderAssessment },
  props: {
    patientData: {
      type: Object,
      default: null,
    },
    idRegistration: {
      type: String,
      default: null,
    },
    rmNumber: {
      type: String,
      default: null,
    },
    isIhs: {
      type: Boolean,
      default: null,
    },
    isEmr: Boolean,
    emrData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      headerData: null,
      patient: null,
      isLoading: true,
    };
  },
  mounted() {
    this.getSocialData();
  },
  methods: {
    navigateTo(ref) {
      const el = this.$refs.assessment.$refs[ref];
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
    async getSocialData() {
      try {
        this.isLoading = true;
        const response = await getSocialDataByRmNumber(
          this.patientData?.rmNumber || this.rmNumber,
        );
        this.assignHeaderData(response.data.data);
        this.assignPatientDataForProps(response.data.data);
      } catch {
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }
    },
    assignHeaderData(data) {
      this.headerData = [
        {
          label: 'No.RM',
          text: this.patientData?.rmNumber || this.rmNumber,
        },
        {
          label: 'Nama',
          text: `${data.name} (${data.gender ? 'L' : 'P'})`,
        },
        {
          label: 'Tanggal Lahir',
          text: `${moment(data.birth.date, 'YYYY-MM-DD').format(
            'DD/MM/YYYY',
          )} (${this.ageDuration(moment(data.birth.date, 'YYYY-MM-DD'))})`,
        },
        {
          label: 'Hambatan dalam Berkomunikasi',
          text: data.commmunication_obstacles || 'Tidak Ada',
        },
      ];
    },
    assignPatientDataForProps(data) {
      this.patient = {
        rmNumber: this.patientData?.rmNumber || this.rmNumber,
        meta: {
          name: data.name,
          address: this.formatAddress(data.address),
          // poly: this.patientData.meta.poly,
          birthDate: moment(data.birth.date, 'YYYY-MM-DD').format(
            'DD MMMM YYYY',
          ),

          bpjs: {
            number: data.assurance.number,
          },
          age: data.age,
          gender: data.gender,
          guarantorType: data.assurance.type,
          // poly: this.patientData.meta.poly,
          guarantorNumber: data.assurance.number,
          rmNumber: this.patientData?.rmNumber || this.rmNumber,
          // address: formatAddress(data.address),
          // address: data.address,
          poly: 'Poli Gigi',
        },
        // rmNumber: this.patientData.rmNumber,
        id_registration:
          this.patientData?.id_registration || this.idRegistration,
        id_emr: data.id_emr,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.dental-main {
  font-family: 'Roboto';
  height: 90vh;
  max-height: 700px;
  width: 1200px;
  max-width: 95vw;
}

.content-wrapper {
  flex-grow: 1;
  overflow: hidden;
  height: 100%;
}

.form-container {
  height: 100%;
}

.sidebar-container {
  height: 100%;
}
</style>
